import { render } from "./RegionView.vue?vue&type=template&id=318da73a&scoped=true"
import script from "./RegionView.vue?vue&type=script&lang=js"
export * from "./RegionView.vue?vue&type=script&lang=js"

import "./RegionView.vue?vue&type=style&index=0&id=318da73a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-318da73a"]])

export default __exports__